<svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="bar-chart-2">
<path id="Vector" d="M23 25V12.5" stroke="#E9897D" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path id="Vector_2" d="M15.5 25V5" stroke="#E9897D" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path id="Vector_3" d="M8 25V17.5" stroke="#E9897D" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
